import React, { useEffect, useState } from "react";
import ReusableTable from "../../../components/common/table";
import { Space } from "antd";
import CommonFilter from "../../../components/common/filter";
import trimSearchValue, { useDebounce } from "../../../customHooks";
import { useDispatch, useSelector } from "react-redux";
import { getUserActivityData } from "../../../redux/action/user-management/userManagementAction";
import dayjs from "dayjs";

const UserActivityList = () => {
  const dispatch = useDispatch();

  const [tableParams, setTableParams] = useState({
    page: 1,
    size: 10,
    search_value: "",
    search_key: "",
    status: undefined,
    position: undefined,
    from_date: undefined,
    to_date: undefined,
  });

  const columns = [
    {
      title: "S. No.",
      dataIndex: "sr_no",
      key: "sr_no",
      width: "60px",
      render: (text, record, index) =>
        (tableParams.page - 1) * tableParams.size + index + 1,
    },
    {
      title: "User Name",
      dataIndex: "user_name_en",
      key: "user_name_en",
      type: "search",
      width: "160px",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      type: "search",
    },
    {
      title: "Podcast Name",
      dataIndex: "podcast_title_en",
      key: "podcast_title_en",
      type: "search",
    },
    {
      title: "Play Duration",
      dataIndex: "duration",
      key: "duration",
      width: "150px",
      render: (durationInSeconds) => {
        const minutes = Math.floor(durationInSeconds / 60);
        const seconds = durationInSeconds % 60;
        return `${minutes}m ${seconds}s`;
      },
    },
    {
      title: "Date",
      dataIndex: "created_at",
      key: "created_at",
      type: "date",
      width: "160px",
      render: (date) => {
        const dateObject = new Date(date);
        const day = String(dateObject.getUTCDate()).padStart(2, "0");
        const month = String(dateObject.getUTCMonth() + 1).padStart(2, "0");
        const year = dateObject.getUTCFullYear();
        return `${month}-${day}-${year}`;
      },
      // render: (created_at) =>
      //   created_at ? dayjs(created_at).format("MM-DD-YYYY") : "-",
    },
  ];

  const debouncedSearchValue = useDebounce(tableParams.search_value, 500);

  useEffect(() => {
    
    dispatch(getUserActivityData(trimSearchValue(tableParams)));
  }, [
    debouncedSearchValue,
    tableParams.status,
    tableParams.position,
    tableParams.page,
    tableParams.size,
    tableParams.from_date,
    tableParams.to_date,
  ]);

  const handleFilterChange = (key, value, reset = false) => {
    

    setTableParams((prev) => {
      if (reset) {
        return {
          ...prev,
          search_key: "",
          search_value: "",
          status: undefined,
          position: undefined,
          from_date: undefined,
          to_date: undefined,
        };
      }
      if (key === "created_at" && (!value || !value.from_date)) {
        return {
          size: prev.size,
          page: prev.page,
        };
      }
      if (key === "status" || key === "position") {
        return {
          ...prev,
          [key]: value,
          search_key: "",
          search_value: "",
        };
      }
      if (typeof value === "object" && value?.from_date) {
        return {
          ...prev,
          from_date: value?.from_date,
          to_date: value?.to_date,
          search_value: "",
          search_key: "",
          status: undefined,
          position: undefined,
        };
      }
      return {
        ...prev,
        search_key: key,
        search_value: value,
        status: undefined,
        position: undefined,
      };
    });
  };

  const datas = useSelector((store) => store.getUserActivityLog?.data);
  const { isLoading } = useSelector((store) => store.getUserActivityLog);

  const paginationConfig = {
    pageSizeOptions: ["10", "20", "50"],
    showSizeChanger: true,
    showQuickJumper: true,
    total: datas?.count ?? 0,
    current: tableParams.page,
    pageSize: tableParams.size,
    onChange: (page, pageSize) => {
      // setCurrentPage(page);
      setTableParams((prev) => ({ ...prev, page, size: pageSize }));
    },
  };

  return (
    <div>
      <div className="addBx">
        <div className="filterBx">
          <Space>
            <CommonFilter
              columns={columns}
              onFilterChange={handleFilterChange}
            />
          </Space>
        </div>
      </div>
      <div className="tableHeading">User Activity Log</div>
      <ReusableTable
        columns={columns}
        data={datas?.rows ?? []}
        loading={isLoading}
        actionItems={[]}
        paginationConfig={{
          ...paginationConfig,
          ...tableParams.pagination,
        }}
      />
    </div>
  );
};

export default UserActivityList;
